export default function EmailBlacklistList({ list, onDelete }) {
  const getTable = (list) => {
    let tables = [];
    if (list) {
      for (let i = 0; i < list.length; i++) {
        const domain = list[i];
        tables.push(
          <tr key={domain._id}>
            <th scope="row">
              <div className="media align-items-center">
                <div className="name mb-0 h6 text-sm">{domain.domain}</div>
              </div>
            </th>
            <th scope="row">
              <div className="media align-items-right ">
                <button
                  type="button"
                  onClick={() => {
                    onDelete(domain);
                  }}
                  className="btn p-0 m-0"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="Delete"
                >
                  <span className="fas fa-trash text-danger"></span>
                </button>
              </div>
            </th>
          </tr>
        );
      }
      return tables;
    }
    return null;
  };
  return (
    <div>
      <div className="table-responsive">
        <table className="table align-items-center">
          <thead>
            <tr>
              <th scope="col" className="sort" data-sort="name">
                Domain
              </th>
              <th scope="col" style={{ width: "140px" }} className="text-end">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="list">{getTable(list)}</tbody>
        </table>
      </div>
    </div>
  );
}
